import { render, staticRenderFns } from "./update-travel.vue?vue&type=template&id=c284f1b0&scoped=true&"
import script from "./update-travel.vue?vue&type=script&lang=ts&"
export * from "./update-travel.vue?vue&type=script&lang=ts&"
import style0 from "./update-travel.vue?vue&type=style&index=0&id=c284f1b0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c284f1b0",
  null
  
)

component.options.__file = "update-travel.vue"
export default component.exports